module.exports = __webpack_public_path__ + "img/DoubleBigWheel3510Play_DG.0e218b02.png";